// extracted by mini-css-extract-plugin
module.exports = {"mySwitch":"style_mySwitch__sLRVV"};